import { useEffect } from 'react';
import { useUnmount, useUpdateEffect } from 'react-use';

import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import {
   AppointmentAdvancePayment,
   AppointmentAdvancePaymentQuery,
} from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { VisitSettlementQuery } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { refetchCqrsQuery, useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';

import { usePrescriptionVisitAdvancePaymentGlobalState } from './usePrescriptionVisitAdvancePaymentGlobalState';

const DEFAULT_PAGINATION = paginations.all();

type PrescriptionVisitAdvancePaymentResolverProps = {
   readonly appointmentIds: number[];
};

export const PrescriptionVisitAdvancePaymentResolver = (props: PrescriptionVisitAdvancePaymentResolverProps): null => {
   const { updateAdvancePayment, resetAdvancePayment } = usePrescriptionVisitAdvancePaymentGlobalState();

   const { data: advancePayments } = useCqrsSearch<AppointmentAdvancePayment>(() => {
      const query = new AppointmentAdvancePaymentQuery();
      query.appointmentIds = props.appointmentIds.map((id) => AppointmentId.of(id));
      return query;
   }, DEFAULT_PAGINATION);

   useEffect(() => {
      if (!advancePayments) {
         return;
      }
      const resultMap: Map<number, AppointmentAdvancePayment> = new Map(
         advancePayments.map((ap) => [ap.appointmentId.asNumber(), ap])
      );

      updateAdvancePayment(resultMap);
   }, [advancePayments, props.appointmentIds, updateAdvancePayment]);

   useUpdateEffect(() => {
      refetchCqrsQuery(VisitSettlementQuery);
   }, [advancePayments]);

   useUnmount(resetAdvancePayment);

   return null;
};
